<template>
  <div class="cmbCheckList">
    <h1>定额监控</h1>
    <el-form :inline="true">
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFind()">查询</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="show.addShow = true">新增</el-button>
          <el-button type="warning" :disabled="show.selected.length != 1" @click="set()">修改</el-button>
          <el-button type="danger" :disabled="show.selected.length < 1" @click="del()">删除</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.cmbCheckList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="方式">
        <template #default="scope">
          <el-text type="danger" v-show="scope.row.checkMode == 'BUY'">买入</el-text>
          <el-text type="success" v-show="scope.row.checkMode == 'SALE'">卖出</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="checkPrice" label="检测价格" />
      <el-table-column prop="remark" label="备注" />
      <el-table-column label="开启">
        <template #default="scope">
          <el-switch v-model="scope.row.hasUsing" size="small" @change="setHasUsing(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
  </div>

  <el-dialog v-model="show.addShow" title="新增" width="550" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="addCmbCheckParam" label-width="auto">
      <el-form-item label="检查方式">
        <el-radio-group v-model="addCmbCheckParam.checkMode">
          <el-radio-button label="买入价" value="BUY" />
          <el-radio-button label="卖出价" value="SALE" />
        </el-radio-group>
      </el-form-item>
      <el-form-item label="监控价格">
        <el-input-number :controls="false" :precision="2" v-model="addCmbCheckParam.checkPrice" style="width: 100%;" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="addCmbCheckParam.remark" style="width: 100%;" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="show.addShow = false">取消</el-button>
        <el-button type="primary" @click="commitAddCmbCheck()">确定</el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog v-model="show.setShow" title="修改" width="550" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="setCmbCheckParam" label-width="auto">
      <el-form-item label="ID">
        <el-text>{{ setCmbCheckParam.id }}</el-text>
      </el-form-item>
      <el-form-item label="检查方式">
        <el-radio-group v-model="setCmbCheckParam.checkMode">
          <el-radio-button label="买入价" value="BUY" />
          <el-radio-button label="卖出价" value="SALE" />
        </el-radio-group>
      </el-form-item>
      <el-form-item label="监控价格">
        <el-input-number :controls="false" :precision="2" v-model="setCmbCheckParam.checkPrice" style="width: 100%;" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="setCmbCheckParam.remark" style="width: 100%;" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="show.setShow = false">取消</el-button>
        <el-button type="primary" @click="commitSetCmbCheck()">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const data = reactive({
  cmbCheckList: [],
})

const show = reactive({
  addShow: false,
  setShow: false,
  selected: [],
})

const commitFind = () => {
  api.get('/backend/cmbGold/getMyCmbGoldCheck').then(res => {
    data.cmbCheckList = res.list
  })
}
commitFind()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}


const addCmbCheckParam = reactive({})
const resetAddCmbCheckParam = () => {
  addCmbCheckParam.checkMode = null
  addCmbCheckParam.checkPrice = null
  addCmbCheckParam.remark = null
}
resetAddCmbCheckParam()

const commitAddCmbCheck = () => {
  api.post('/backend/cmbGold/addCmbGoldCheck', addCmbCheckParam).then(res => {
    ElMessage.success('新增成功')
    show.addShow = false
    commitFind()
    resetAddCmbCheckParam()
  })
}

const setHasUsing = (row) => {
  api.post('/backend/cmbGold/setMyCmbGoldCheck', {
    id: row.id,
    hasUsing: row.hasUsing
  }).then(res => {
    ElMessage.success('设置成功')
    commitFind()
  }).catch(res => {
    commitFind()
  })
}

const setCmbCheckParam = reactive({})
const resetSetCmbCheckParam = () => {
  setCmbCheckParam.id = null
  addCmbCheckParam.checkMode = null
  setCmbCheckParam.checkPrice = null
  setCmbCheckParam.remark = null
}
resetSetCmbCheckParam()

const set = () => {
  const row = tabRef.value.getSelectionRows()[0]
  setCmbCheckParam.id = row.id
  setCmbCheckParam.checkMode = row.checkMode
  setCmbCheckParam.checkPrice = row.checkPrice
  setCmbCheckParam.remark = row.remark
  show.setShow = true
}

const commitSetCmbCheck = () => {
  api.post('/backend/cmbGold/setMyCmbGoldCheck', setCmbCheckParam).then(res => {
    ElMessage.success('修改成功')
    show.setShow = false
    commitFind()
    resetSetCmbCheckParam()
  })
}

const del = () => {
  const ids = tabRef.value.getSelectionRows().map(item => item.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的 ' + ids.length + ' 项。',
    autofocus: false,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  }).then(() => {
    api.post('/backend/cmbGold/delMyCmbGoldCheck', { ids: ids }).then(() => {
      ElMessage.success('删除成功')
      commitFind()
    })
  })
}

</script>

<style lang="less"></style>